import { render, staticRenderFns } from "./MyProjectsTable.vue?vue&type=template&id=164555a9&scoped=true&"
import script from "./MyProjectsTable.vue?vue&type=script&lang=js&"
export * from "./MyProjectsTable.vue?vue&type=script&lang=js&"
import style0 from "./MyProjectsTable.vue?vue&type=style&index=0&id=164555a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164555a9",
  null
  
)

export default component.exports